
import React, { useEffect, useRef, useState } from 'react'
import { Tabs, Carousel, Spin, Button, Card } from 'antd'
import { themecolor } from '../../../config'
import './mobileView.scss'
import { dashboard } from '../../../Common/data/mobileView/Dashboard'
import moment from 'moment-timezone'
import topIconSetLight from '../../../../src/assets/images/app_header_top_iconset.png';
import prevArrowWhite from '../../../../src/assets/images/prevArrowWhite.png'
import contactIcon2 from '../../../../src/assets/images/contact_icon_white2.png'
import accessIcon from '../../../../src/assets/images/app_access_icon.png'
import { businessMain, businessAbout } from '../../../Common/data/mobileView/BusinessPage'
import { useLocation, useNavigate } from 'react-router-dom'
import Advertisement from '../../Components/Advertisement/Advertisement'
import { useDispatch, useSelector } from 'react-redux'
import ListingView from '../mobile/ListingView/ListingView'
import DashboardView from '../mobile/DashboardView/DashboardView'
import { getMobileData, getMobileListingData } from '../../../slices/mobile-view/thunk'
import { getWorks } from '../../../slices/works/thunk'
import { getCatalogue } from '../../../slices/catalog/thunk'
import { businessInfo } from '../../../slices/businessInfo/thunk'
import { getAllAds, getLiveAds } from '../../../slices/ads/thunk'
import NoResults from '../../Components/NoResults/NoResults'
import { ShimmerCategoryItem } from "react-shimmer-effects";
import Log from '../../../Services/Log'
import worksImage from '../../../../src/assets/images/works_icon2.svg';
import catalogImage from '../../../../src/assets/images/catalog_icon2.svg';
import { getCatalogMob } from '../../../slices/mobCatalog/thunk'
import { getVerifiedStatus } from '../../../Services/LocalStorageService'
import ProfileNotVerifiedPopup from '../../../Common/profileNotVerifiedPopup/ProfileNotVerifiedPopup'
import Avatar from '../../Components/Avatar/Avatar'




const MobileView = ({ type, active, className, triggerUpdate, workTrigger, fromCatalogData = false, updatedCatalogData, updatedWorksData }) => {
    document.title = "Mobile View"
    const navigate = useNavigate();
    let previewType = '';
    let [parent, child] = [useRef(), useRef()]
    let defaultTabsActive = () => {
        switch (active) {
            case '3':
                handleTab(1)

                break;
            case '4':
                handleTab(2)
                break;
            default:
            case '4':
                break;
        }
    }
    useEffect(() => {
        if (active) {
            defaultTabsActive();
        }
    }, [active]);

    const [parentTabActive, setParentTabActive] = useState(active || '1');
    const [tab, setTab] = useState(1);
    const [currentTime, setCurrentTime] = useState(moment().tz("Asia/Kolkata").format('h:mm'));

    const dispatch = useDispatch();
    const { pathname } = useLocation();


    const [worksData, setWorksData] = useState(useSelector((state) => state.Works));
    const [catalogData, setCatalogData] = useState({ items: [] });
    const [businessInfoData, setBusinessInfoData] = useState(useSelector((state) => state.BusinessInfoReducer))
    const [liveProfiles, setLiveProfiles] = useState(useSelector((state) => state.Profiles))
    const [adsPresent, setAdsPresent] = useState(false)
    const [socialMediaAttributes, setSocialMediaAttributes] = useState(false)
    const [status, setStatus] = useState('false');
    const [profileNotVerifiedModal, setProfileNotVerifiedModal] = useState(false);
    const [scrollVisible, setScrollVisible] = useState(true);

    const shimmer = <>
        <Card>
            <ShimmerCategoryItem />
            <ShimmerCategoryItem
                hasImage
                imageType="thumbnail"
                imageWidth={100}
                imageHeight={100}
                title
            />

            <ShimmerCategoryItem
                hasImage
                imageType="circular"
                imageWidth={100}
                imageHeight={100}
                title
            />

            <ShimmerCategoryItem
                hasImage
                imageType="thumbnail"
                imageWidth={100}
                imageHeight={100}
                text
            />

            <ShimmerCategoryItem
                hasImage
                imageType="circular"
                imageWidth={100}
                imageHeight={100}
                text
            />

            <ShimmerCategoryItem
                hasImage
                imageType="thumbnail"
                imageWidth={100}
                imageHeight={100}
                text
                cta
            />

            <ShimmerCategoryItem
                hasImage
                imageType="circular"
                imageWidth={100}
                imageHeight={100}
                text
                cta
            />
        </Card>
    </>

    useEffect(() => {
        if (triggerUpdate) {
            setTimeout(() => {
                if (previewType === 'Works') {
                    dispatch(getWorks({ limit: 30, page: 1 }));
                }
                else {
                    dispatch(getCatalogMob());
                }
            }, 200)
        }
    }, [triggerUpdate])
    useEffect(() => {
        if (liveProfiles?.profiles.length > 0) {
            dispatch(getAllAds({ status: 'all', page: 1, limit: 6 }));
        }
    }, [liveProfiles])

    useEffect(() => {
        dispatch(getAllAds({ status: 'all', page: 1, limit: 6 }));
    }, [])

    useEffect(() => {
        setStatus(getVerifiedStatus())
    }, [getVerifiedStatus])


    useEffect(() => {
        console.log('status', status)
    }, [status])






    useEffect(() => {
        switch (parentTabActive) {
            case '1':
                if (liveProfiles?.profiles) {
                    if (adsPresent) {
                        dispatch(getMobileData(true));
                    }
                    else {
                        dispatch(getMobileData(false));
                    }
                }
                break;
            case '2':
                if (adsPresent) {
                    dispatch(getMobileListingData(true));
                }
                else {
                    dispatch(getMobileListingData(false));
                }
                break;
            case '3':
                if (!worksData.length) {
                    dispatch(getWorks({ limit: 30, page: 1 }));
                }
                if (!businessInfoData.length) {
                    dispatch(businessInfo());
                }
                if (!liveProfiles.profiles?.length) {
                    dispatch(getLiveAds("active"))
                }
                break;
            case '4':
                if (catalogData?.data?.length === 0) {
                    dispatch(getCatalogue({ limit: 15, page: 1 }))
                }
                if (!businessInfoData.length) {
                    dispatch(businessInfo());
                }
                break;
            case '5':
                if (!businessInfoData.length) {
                    dispatch(businessInfo());
                }
                break;
            default:
                break;
        }
    }, [parentTabActive, active, worksData, businessInfoData, catalogData, dispatch, adsPresent, liveProfiles]);


    // fetching data from the store

    const mobDashboardData = useSelector((state) => state.MobileViewDashboard);
    const mobListingData = useSelector((state) => state.MobileViewListing);
    const mobWorksData = useSelector((state) => state.Works)
    const mobCatalogData = useSelector((state) => state.Catalog);
    const state = useSelector((state) => state)
    const mobBusinessInfo = useSelector((state) => state.BusinessInfoReducer)
    const mobLiveProfiles = useSelector((state) => state.Profiles)
    const mobLiveAds = useSelector((state) => state.Profiles)
    useEffect(() => {
        if (mobCatalogData?.data?.length > 0) {
            setCatalogData((prev) => {
                // Combine the existing items with the new data
                const updatedData = [...prev.items, ...mobCatalogData?.data];

                // Filter out duplicates based on the 'title' key
                const uniqueData = Array.from(new Set(updatedData.map(item => item?.title)))
                    .map(title => updatedData.find(item => item?.title === title));

                return { items: uniqueData };
            });
        }
    }, [mobCatalogData]);
    // Dashboard Advertisement

    const [dashboardAd, setDashboardAd] = useState(null);
    const [dashboardAdData, setDashboardAdData] = useState(null);
    const [dashboardAdAction, setDashboardAdAction] = useState(null);
    const [dashboardAdIcon, setDashboardAdIcon] = useState(null);
    const [dashboardAdTitle, setDashboardAdTitle] = useState(null);
    const [dashboardAdBanner, setDashboardAdBanner] = useState(null);

    useEffect(() => {
        if (mobDashboardData.data.dashboard && mobDashboardData.data.dashboard.length > 0) {
            const adData = mobDashboardData.data.dashboard.find(item => item.type === 'market-place-ad-listing');
            if (adData) {
                setDashboardAd(true);
                setDashboardAdData(adData);
                setDashboardAdAction(adData.ad_data?.call_to_action?.type);
                setDashboardAdIcon(adData.ad_data?.call_to_action?.light_icon);
                setDashboardAdTitle(adData.ad_data?.call_to_action?.title);
                setDashboardAdBanner(adData.ad_data?.ad_images[0].thumbnail);
            } else {
                setDashboardAd(false);
            }
        }
        // dispatch(getLiveAds())
    }, [mobDashboardData]);

    // Listing Advertisement
    const [adPresent, setAdPresent] = useState(false)
    const [listingAd, setListingAd] = useState(null);
    const [listingAdData, setListingAdData] = useState(null);
    const [listingAdAction, setListingAdAction] = useState(null);
    const [listingAdIcon, setListingAdIcon] = useState(null);
    const [listingAdTitle, setListingAdTitle] = useState(null);
    const [listingAdBanner, setListingAdBanner] = useState(null);

    useEffect(() => {
        if (mobDashboardData.data.dashboard && mobDashboardData.data.dashboard.length > 0) {
            const adData = mobDashboardData.data.dashboard.find(item => item.type === 'market-place-ad-listing');
            if (adData) {
                setListingAd(true);
                setListingAdData(adData);
                setListingAdAction(adData.ad_data?.call_to_action?.type);
                setListingAdIcon(adData.ad_data?.call_to_action?.light_icon);
                setListingAdTitle(adData.ad_data?.call_to_action?.title);
                setListingAdBanner(adData.ad_data?.ad_images[0].thumbnail);
            } else {
                setListingAd(false);
            }

        }
    }, [mobListingData]);


    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [pathname]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(moment().tz("Asia/Kolkata").format('h:mm'));
        }, 60000); // Update every minute

        return () => clearInterval(timer);
    }, []);

    let instagram = mobBusinessInfo?.businessInfo?.instagram;
    let facebook = mobBusinessInfo?.businessInfo?.facebook;
    let whatsapp = mobBusinessInfo?.businessInfo?.whatsapp;
    let website = mobBusinessInfo?.businessInfo?.website;


    useEffect(() => {
        if (instagram || facebook || whatsapp) {
            setSocialMediaAttributes(true)
        }
        console.log('mobBusinessInfo?.businessInfo?.old_business_logo?.original', mobBusinessInfo?.businessInfo?.old_business_logo?.original)
    }, [mobBusinessInfo])

    useEffect(() => {
        dispatch(getWorks({ limit: 30, page: 1 }));
    }, [workTrigger])



    // ads 
    useEffect(() => {
        if (updatedCatalogData?.length > 0 || mobWorksData.data?.length > 0) {
            if ((parent.current && child.current) && (!mobCatalogData?.loading && !worksData?.loading)) {
                let parentHeight = parent.current.offsetHeight;
                let childHeight = child.current.offsetHeight;
                if ((childHeight ) < parentHeight) {
                    setScrollVisible(false)
                }
                else {
                    setScrollVisible(true)
                }
            }
        }

    }, [updatedCatalogData, mobWorksData?.data])

    const dashboardView = (
        mobDashboardData.loading ? (
            <>
                {shimmer}
            </>
        ) : (
            <DashboardView currentTime={currentTime} data={mobDashboardData.data} >
                {dashboardAd ? (
                    <Advertisement
                        action={dashboardAdAction}
                        poster={dashboardAdBanner}
                        iconUpdated={dashboardAdIcon}
                        title={dashboardAdTitle}
                    />
                ) :
                    <NoResults
                        className={'center dashboard_no_ad'}
                        title={'Create Your Ad'}>
                        {/* <Button className="wide mb" type='primary' onClick={() => {
                            if (status) {
                                setProfileNotVerifiedModal(true)
                            } else {
                                navigate('/live-ads/new-ads');
                            }
                        }}>Create New Ad</Button> */}
                    </NoResults>
                }
            </DashboardView>
        )
    );
    const listingView = (
        mobDashboardData.loading ? (
            <>
                {shimmer}
            </>
        ) : (
            <ListingView currentTime={currentTime} data={mobListingData.data} className={`${scrollVisible && 'scrollable_arrow'} `}>
                {dashboardAd ? (<Advertisement
                    action={dashboardAdAction}
                    src={dashboard[0]?.advertisement.src}
                    poster={dashboardAdBanner}
                    iconUpdated={dashboardAdIcon}
                    title={dashboardAdTitle}
                />) :
                    <NoResults
                        className={'center listing_no_ad'}
                        title={'Create Your Ad'}>
                        {/* <Button className="wide mb" type='primary' onClick={() => {
                            if (status) {
                                setProfileNotVerifiedModal(true)
                            } else {
                                navigate('/live-ads/new-ads');
                            }
                        }}>Create New Ad</Button> */}
                    </NoResults>
                }

            </ListingView>
        )

    )
    const renderCatalogItems = (items) => {
        mobCatalogData?.data?.map((el, index) => {
            return (
                <div className="app__catalog__cnt" key={el?.id}>
                    <h3><span className='text_capitalize'>{el?.title}</span></h3>
                    <div className="description_cnt">
                        {el?.description.split('\n').map((line, index) => (
                            <p className="text_md" key={index}>
                                {line}
                            </p>
                        ))}
                    </div>
                    <span className='price'>₹{el?.price}</span>
                </div>
            );
        })
    }
    const businessPageView = (
        <div className={`businessPageView  app ${className}`} ref={parent}>
            <div className={`${scrollVisible && 'scrollable_arrow'}  business_page_view`} ref={child}>
                <header>
                    <div className="app__header__top mt">
                        <span className="app__header__top__time">{currentTime}</span>
                        <div className="app__header__top__icons">
                            <img src={topIconSetLight} alt="" loading="lazy" />
                        </div>
                    </div>
                    <span className='app__prev__arrow'><img src={prevArrowWhite} alt="" loading="lazy" /></span>
                    <div className="app__title__wrap header_title_wrap">
                        <div className="app__title__wrap">
                            {!mobBusinessInfo ? (
                                <>
                                    <figure>
                                        {mobBusinessInfo?.businessInfo?.old_business_logo?.original != null ? (
                                            <img
                                                src={mobBusinessInfo.businessInfo.old_business_logo.original}
                                                alt=""
                                                loading="lazy"
                                            />
                                        ) : (
                                            <Avatar className='m0'>
                                                {mobBusinessInfo.businessInfo?.business_name?.[0] || mobBusinessInfo.businessInfo?.old_business_name?.[0]}
                                            </Avatar>
                                        )}
                                    </figure>
                                    <div>
                                        <h3 style={{ marginBottom: 0 }}>{businessInfoData.data?.business_name}</h3>
                                        <span className="app__location">{businessInfoData.data?.business_address}</span>
                                        {/* <span className='app__category'>{businessMain.studio.category}</span> */}
                                    </div>
                                    <p className='app__cnt'>
                                        {businessMain.studio.description}
                                    </p>
                                </>
                            ) : (
                                <>
                                    <figure>
                                        {mobBusinessInfo?.businessInfo?.old_business_logo?.original != null ? (
                                            <img
                                                src={mobBusinessInfo.businessInfo.old_business_logo.original}
                                                alt=""
                                                loading="lazy"
                                            />
                                        ) : (
                                            <Avatar className='m0'>
                                                {mobBusinessInfo.businessInfo?.business_name?.[0] || mobBusinessInfo.businessInfo?.old_business_name?.[0]}
                                            </Avatar>
                                        )}
                                    </figure>
                                    <div>
                                        <h3 style={{ marginBottom: 0 }}>{mobBusinessInfo.businessInfo?.business_name ? mobBusinessInfo.businessInfo?.business_name : mobBusinessInfo.businessInfo?.old_business_name}</h3>
                                        <span className="app__location">{mobBusinessInfo.businessInfo?.business_address ? mobBusinessInfo.businessInfo?.business_address : mobBusinessInfo.businessInfo?.old_business_address}</span>
                                        <span className='app__category'>{mobBusinessInfo.businessInfo?.business_category}</span>
                                    </div>
                                    <p className='app__cnt'>
                                        {mobBusinessInfo.businessInfo?.business_description ? mobBusinessInfo.businessInfo?.business_description : mobBusinessInfo.businessInfo?.old_business_description}
                                    </p>
                                </>
                            )}
                        </div>

                    </div>
                </header>
                <div className="advertisement">
                    {mobLiveAds?.ads?.length === 0 && (
                        <div className="placeholder_ads">
                            <p className="md mb-0 text_red">
                                Your <span className="semibold">Ads</span> will be listed here
                            </p>
                        </div>
                    )}
                    {mobLiveAds?.ads?.length > 1 ? (
                        <Carousel autoplay className="dots_absent">
                            {mobLiveAds?.ads?.map((el, index) =>
                                el.ad_images?.map((img, slno) => (
                                    <img
                                        key={`${index}-${slno}`}
                                        src={img.thumbnail}
                                        alt={`Image ${slno}`}
                                        className="img_full red_shadow cover"
                                    />
                                ))
                            )}
                        </Carousel>
                    ) : (
                        mobLiveAds?.ads?.map((el, index) =>
                            el.ad_images?.map((img, slno) => (
                                <figure key={`${index}-${slno}`} className='add_display single'>
                                    <img src={img.thumbnail} alt={`Ad Image ${slno}`} />
                                </figure>
                            ))
                        )
                    )}
                </div>

                <div className="app__custom__tab businessPageAds">
                    <figure className="app__contact_green">
                        <img src={contactIcon2} alt="" loading="lazy" />
                    </figure>
                    {/* tab button */}
                    <ul className="app__tab__nav">
                        {businessMain?.studio?.tabs?.map((el, index) => {
                            if (active === '3') {
                                previewType = 'Works'
                            }
                            else if (active === '4') {
                                previewType = 'Catalogue'
                            }

                            return (
                                <li
                                    key={index}
                                    className={`${tab === index + 1 ? 'active' : 'inactive'} ${active && previewType !== el?.name && 'disabled'}`}
                                    onClick={() => {
                                        handleTab(index + 1);
                                        console.log('Tab clicked:', index + 1);
                                    }}
                                >
                                    {el.name}
                                </li>
                            );
                        })}
                    </ul>

                    {/* grid */}
                    <div className="app__tab__cnt" style={{ display: tab === 1 ? 'block' : 'none' }}>
                        {worksData.loading || mobWorksData.loading ? (
                            <>
                                {shimmer}
                            </>
                        ) : worksData.data?.length === 0 && mobWorksData.data?.length === 0 ? (
                            // <NoResults
                            //     className={'sm'}
                            //     type={'works'}
                            //     title={'Add works'}
                            //     description={'Showcase your best work and keep everything neatly stored with just a few clicks.'}
                            // />
                            <>
                                <ul className="works_null_list">
                                    {
                                        Array.from({ length: 9 }, (_, i) => (
                                            <li key={i}>
                                                <img src={worksImage} alt="" />
                                            </li>
                                        ))
                                    }
                                </ul>
                            </>
                        ) : (
                            <ul className="app__main__section__cards">
                                {
                                    updatedWorksData?.length > 0 ? (
                                        updatedWorksData.map((el, index) => (
                                            <li key={index} className="red_shadow">
                                                <img src={el?.thumbnail} alt="" loading="lazy" />
                                            </li>
                                        ))
                                    ) : (
                                        (worksData.data?.length !== 0 ? worksData.data : mobWorksData.data)?.map((el, index) =>
                                            el?.verification_status !== 2 && (
                                                <li key={index} className="red_shadow">
                                                    <img src={el?.thumbnail} alt="" loading="lazy" />
                                                </li>
                                            )
                                        )
                                    )
                                }
                            </ul>
                        )}
                    </div>

                    {/* catalogue */}
                    <div className="app__tab__cnt app__catalog" style={{ display: tab === 2 ? 'block' : 'none' }}>
                        {
                            mobCatalogData?.loading ? (
                                <>
                                    {shimmer}
                                </>
                            ) : (
                                <div className="app__tab__cnt_body">
                                    {
                                        // Check if both catalogData?.data and mobCatalogData?.data are empty
                                        ((!catalogData?.items?.length && !mobCatalogData?.data?.length)) && (
                                            <>
                                                <ul className="catalog_null_list">
                                                    {
                                                        Array.from({ length: 9 }, (_, i) => (
                                                            <li key={i}>
                                                                <img src={catalogImage} alt="" />
                                                                <ul>
                                                                    {
                                                                        Array.from({ length: 3 }, (_, i) => (
                                                                            <li key={i}>
                                                                            </li>
                                                                        ))
                                                                    }
                                                                </ul>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </>
                                        )
                                    }
                                    {
                                        // Check if both catalogData?.data and mobCatalogData?.data are empty
                                        (fromCatalogData && updatedCatalogData?.length === 0) && (
                                            <>
                                                <ul className="catalog_null_list">
                                                    {
                                                        Array.from({ length: 9 }, (_, i) => (
                                                            <li key={i}>
                                                                <img src={catalogImage} alt="" />
                                                                <ul>
                                                                    {
                                                                        Array.from({ length: 3 }, (_, i) => (
                                                                            <li key={i}>
                                                                            </li>
                                                                        ))
                                                                    }
                                                                </ul>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </>
                                        )
                                    }
                                    {
                                        // Display updatedData if it exists and is not empty
                                        fromCatalogData ?
                                            updatedCatalogData?.map((el, index) => {
                                                return (
                                                    el?.verification_status !== 2 && <div className="app__catalog__cnt" key={el?.id}>
                                                        <h3><span className="text_capitalize">{el?.title}</span></h3>
                                                        <div className="description_cnt">
                                                            {el?.description.split('\n').map((line, index) => (
                                                                <p className="text_md" key={index}>
                                                                    {line}
                                                                </p>
                                                            ))}
                                                        </div>
                                                        {el?.price !== 0 && <span className='price'>₹{el?.price}</span>}
                                                    </div>
                                                );
                                            }) :
                                            // Display catalogData if updatedData is empty and catalogData exists
                                            catalogData?.items?.length > 0 ?
                                                catalogData?.items?.map((el, index) => {
                                                    return (
                                                        <div className="app__catalog__cnt" key={el?.id}>
                                                            <h3><span className="text_capitalize">{el?.title}</span></h3>
                                                            <div className="description_cnt">
                                                                {el?.description.split('\n').map((line, index) => (
                                                                    <p className="text_md" key={index}>
                                                                        {line}
                                                                    </p>
                                                                ))}
                                                            </div>
                                                            {el?.price !== 0 && <span className='price'>₹{el?.price}</span>}
                                                        </div>
                                                    );
                                                }) : null
                                    }
                                </div>


                            )
                        }

                    </div>
                    {/* about */}
                    <div className="app__tab__cnt" style={{ display: tab === 3 ? 'block' : 'none' }}>
                        {(mobBusinessInfo?.businessInfo?.old_business_address || mobBusinessInfo?.businessInfo?.business_address) ? (
                            <div className="app__businessinfo__cnt address">
                                <h3>Address</h3>
                                <div className="app__location">
                                    <p>{mobBusinessInfo?.businessInfo?.old_business_address ? mobBusinessInfo?.businessInfo?.old_business_address : mobBusinessInfo?.businessInfo?.business_address}</p>
                                    <span><img src={accessIcon} alt="" loading="lazy" /></span>
                                </div>
                            </div>
                        ) : null}

                        <div className="app__businessinfo__cnt contact">
                            <h3>Contact</h3>
                            {mobBusinessInfo ? (
                                <>
                                    <p><span className="text_light"><span>Contact Number</span><span>:</span></span>&nbsp;<span>+91 {mobBusinessInfo.businessInfo?.contact_number}</span></p>
                                    {
                                        (mobBusinessInfo.businessInfo?.old_contact_name || mobBusinessInfo.businessInfo?.contact_name) && (
                                            <p><span className="text_light"><span>Contact Name</span><span>:</span></span>&nbsp;<span>{mobBusinessInfo.businessInfo?.old_contact_name ? mobBusinessInfo.businessInfo?.old_contact_name : mobBusinessInfo.businessInfo?.contact_name}</span></p>
                                        )
                                    }

                                </>
                            ) : null}
                        </div>
                        {
                            socialMediaAttributes ? (<div className="app__businessinfo__cnt social-media">
                                <h3>Social Media</h3>
                                {
                                    whatsapp && (
                                        <p><span className="text_light"><span>Whatsapp</span><span>:</span></span>&nbsp;<span>+91 {whatsapp}</span></p>
                                    )
                                }
                                {
                                    instagram && (
                                        <p><span className="text_light"><span>Instagram</span><span>:</span></span>&nbsp;<span>{instagram}</span></p>
                                    )
                                }
                                {
                                    facebook && (
                                        <p><span className="text_light"><span>Facebook</span><span>:</span></span>&nbsp;<span>{facebook}</span></p>
                                    )
                                }
                                {
                                    website && (
                                        <p className='mb-0'><span className="text_light"><span>Website</span><span>:</span></span>&nbsp;<span>{website}</span></p>
                                    )
                                }
                            </div>) : ''
                        }

                    </div>
                </div>
            </div>
        </div >
    )
    const handleTab = ((id) => {
        setTab(id);
        switch (id) {
            case 1:
                setParentTabActive('3');
                break;
            case 2:
                setParentTabActive('4');
                break;
            case 3:
                setParentTabActive('5');
                break;
            default:
                break;
        }

    })
    const handleParentTabChange = ((key) => {
        setParentTabActive(key);

        if (key > 2) {
            setTab(key - 2)
        }
    })

    const handleScroll = () => {
        if (window.innerWidth <= 1199) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
    useEffect(() => {
        console.log('mobWorksData.data', mobWorksData.data)
    }, [mobWorksData.data])
    return (
        <>
            <section className={`${type} ${className}`} >
                <div className="vertical_tab mobile_view " >
                    <Tabs
                        tabPosition='left'
                        onChange={handleParentTabChange}
                        activeKey={parentTabActive}
                        items={[
                            {
                                label: (
                                    <div className='tab_cnt' onClick={handleScroll} style={{ display: "flex", alignItems: "center", textAlign: "left" }}>
                                        <span className='selected relative lg'></span>
                                        <div>
                                            <h4 className='text_red text_md'>Dashboard Screen</h4>
                                            <p className="mb-0 md">Your ad will be displayed on the main dashboard, along with the call to action you choose, ensuring maximum reach and engagement.</p>
                                        </div>
                                    </div>
                                ),
                                key: '1',
                                children: (
                                    dashboardView
                                ),
                            },
                            {
                                label: (
                                    <div className='tab_cnt' onClick={handleScroll} style={{ display: "flex", alignItems: "center", textAlign: "left" }}>
                                        <span className='selected relative lg'></span>
                                        <div>
                                            <h4 className=' text_md text_red'>Listing View</h4>
                                            <p className="mb-0 md">Your ad will appear in the listing section, highlighting the call to action you choose, ensuring optimal visibility and driving user engagement.</p>
                                        </div>
                                    </div>
                                ),
                                key: '2',
                                children: (
                                    listingView
                                )
                            },
                            {
                                label: (
                                    <div className='tab_cnt' onClick={handleScroll} style={{ display: "flex", alignItems: "center", textAlign: "left" }}>
                                        <span className='selected relative lg'></span>
                                        <div>
                                            <h4 className=' text_md text_red'>Business Page - Main </h4>
                                            <p className="mb-0 md">Your business details are displayed here, with your ads showcased and your best works highlighted. This gives potential customers a comprehensive view of what you offer.</p>
                                        </div>
                                    </div>
                                ),
                                key: '3',
                                children: (
                                    businessPageView
                                )
                            },
                            {
                                label: (
                                    <div className='tab_cnt' onClick={handleScroll} style={{ display: "flex", alignItems: "center", textAlign: "left" }}>
                                        <span className='selected relative lg'></span>
                                        <div>
                                            <h4 className=' text_md text_red'>Business Page - Catalogue </h4>
                                            <p className="mb-0 md">Your business catalogs are displayed here, with your products and services highlighted, making it easy for customers to explore and select what they need.</p>
                                        </div>
                                    </div>
                                ),
                                key: '4',
                                children: (
                                    businessPageView
                                )
                            },
                            {
                                label: (
                                    <div className='tab_cnt' onClick={handleScroll} style={{ display: "flex", alignItems: "center", textAlign: "left" }}>
                                        <span className='selected relative lg'></span>
                                        <div>
                                            <h4 className=' text_md text_red'>Business Page - About </h4>
                                            <p className="mb-0 md">Your business story is shared here, highlighting your mission, values, and what sets you apart, providing customers with insight into your expertise and the quality they can expect from your products and services.</p>
                                        </div>
                                    </div>
                                ),
                                key: '5',
                                children: (
                                    businessPageView
                                )
                            },
                        ]}
                    />
                </div>
            </section>
            <ProfileNotVerifiedPopup status={true} />

        </>
    )
}

export default MobileView;